import {PublicClientApplication} from '@azure/msal-browser'

const msalConfig = {
  auth: {
    clientId: process.env.REACT_APP_CLIENT_ID || '',
    redirectUri: encodeURI(process.env.REACT_APP_AD_REDIRECT_BACK || ''),
    authority: `https://login.microsoftonline.com/${process.env.REACT_APP_TENANT_ID || ''}`,
  },
  cache: {
    cacheLocation: 'localStorage',
    storeAuthStateInCookie: false,
  },
}

export const pca = new PublicClientApplication(msalConfig)
export const loginRequest = {
  scopes: ['User.Read'],
}
